import { doc, setDoc, Timestamp, type DocumentReference } from 'firebase/firestore';
import { inquiriesRef } from './read';
import type { InquiryCreateData, InquiryData } from '../../../../types/inquiry';
import { auth } from '../../config';

/**
 * お問い合わせ情報を新規登録
 * @param input - お問い合わせ登録情報
 * @returns 作成されたお問い合わせのドキュメントリファレンス
 */
export const createInquiry = async (input: InquiryCreateData): Promise<DocumentReference> => {
  // 新しいお問い合わせドキュメントの参照を作成
  const inquiryDocRef = doc(inquiriesRef);

  // 現在のユーザーUID取得
  const currentUser = auth.currentUser;
  if (!currentUser) {
    throw new Error('ユーザーが認証されていません');
  }

  // 登録日時
  const now = Timestamp.now();

  // Firestoreに保存するデータを作成
  const inquiryData: InquiryData = {
    inquiry_id: inquiryDocRef.id,
    company_id: input.company_id,
    user_id: input.user_id,
    category: input.category,
    message: input.message,
    contact_name: input.contact_name,
    contact_email: input.contact_email,
    contact_phone: input.contact_phone,
    company_name: input.company_name,
    department: input.department,
    completed_at: null,
    created_at: now,
    updated_at: now,
    created_by: currentUser.uid,
    updated_by: currentUser.uid,
  };

  // Firestoreに保存
  await setDoc(inquiryDocRef, inquiryData);

  return inquiryDocRef;
};
